import React, { useState, useEffect } from 'react';
import api from '../../api';
import Counter from "./Counter";

const FactCounter = () => {
  const [counters, setCounters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCounters = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/fact-counters`);
        if (response.data.status) {
          setCounters(response.data.data);
        } else {
          setError(response.data.message);
          // Fallback data with prefix/suffix examples
          setCounters([
            {
              id: 1,
              title: 'History of High Achievers',
              end_value: 2500,
              value_type: 'prefix',
              value_text: '+',
              duration: 3000,
              order: 1,
              is_active: true
            },
            {
              id: 2,
              title: 'Success Rate',
              end_value: 95,
              value_type: 'suffix',
              value_text: '%',
              duration: 3000,
              order: 2,
              is_active: true
            },
            // Add more fallback counters as needed
          ]);
        }
      } catch (err) {
        setError(err.message);
        // Fallback data with prefix/suffix examples
        setCounters([
          {
            id: 1,
            title: 'History of High Achievers',
            end_value: 2500,
            value_type: 'prefix',
            value_text: '+',
            duration: 3000,
            order: 1,
            is_active: true
          },
          {
            id: 2,
            title: 'Success Rate',
            end_value: 95,
            value_type: 'suffix',
            value_text: '%',
            duration: 3000,
            order: 2,
            is_active: true
          },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchCounters();
  }, []);

  // Function to format the counter display based on prefix/suffix
  const formatCounterDisplay = (counter) => {
    const { value_type, value_text, end_value } = counter;
    
    if (!value_type || !value_text) {
      return <Counter end={end_value} duration={counter.duration} />;
    }

    if (value_type === 'prefix') {
      return (
        <span className="counter-with-format">
          <span className="prefix-text">{value_text}</span>
          <Counter end={end_value} duration={counter.duration} />
        </span>
      );
    } else if (value_type === 'suffix') {
      return (
        <span className="counter-with-format">
          <Counter end={end_value} duration={counter.duration} />
          <span className="suffix-text">{value_text}</span>
        </span>
      );
    }

    return <Counter end={end_value} duration={counter.duration} />;
  };

  if (loading) return <></>;
  if (error) return <></>;
  if (counters.length === 0) return <></>;

  return (
    <section className="fact-counter-area">
        <div className="container">
            <div className="sec-title text-center pt-2">
                <h2>Most Interesting Facts</h2>
            </div>
            <div className="row">
                <div className="col-xl-12">
                  <ul className="fact-counter-box">
                    {counters.map((counter, index) => (
                      <li
                        key={counter.id}
                        className={`single-fact-counter ${index === counters.length - 1 ? 'border-0' : ''}`}
                      >
                        <div className="title-holder">
                          <div className="count-outer count-box">
                            {formatCounterDisplay(counter)}
                          </div>
                          <h3>{counter.title}</h3>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
            </div>
        </div>
    </section>
  );
};

export default FactCounter;